import { Card, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { Recurrence } from 'models';
import { nextAutomationDatetimes } from 'models/recurrence/recurrence_helpers';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import ConciseDateAndTime from '../fields/datetimes/ConciseDateAndTime';
import { makeProjectedRecurrence, ProjectedRecurrence } from '../fields/datetimes/DatetimeList';
import FieldWrapperGizmo from '../fields/FieldWrapperGizmo';




const ProjectedRecurrenceCard = ({ projected } : { projected: ProjectedRecurrence }) =>
{
	return (
		<Card
			sx={{
				padding: 1,
			}}
			key={projected._id}
		>
			<Typography
				variant='h3'
			>
				{projected.title}
			</Typography>
			<Stack
				direction='row'
			>
				<Typography
					component='span'
					sx={{
					}}
				>
					<Typography
						component='span'
						sx={{
							opacity: .45,
						}}
					>
						{'Due: '}
					</Typography>
					{projected.datetime_elem}
				</Typography>
			</Stack>
			<Typography>
				{projected.subtitle}
			</Typography>
		</Card>
	)
}




const ProjectionNote = ({ dt } : { dt?: DateTime }) =>
{
	let content : ReactNode;
	
	
	if(!dt)
	{
		content = <>
			Generating immediately
		</>
	}
	else
	{
		content = <>
			Generating on {<ConciseDateAndTime datetime={dt} />}
		</>
	}
	
	
	return (
		<Typography
			sx={{
				opacity: .55,
				marginLeft: -3,
			}}
		>
			{content}
		</Typography>
	)
}





export const RecurrenceProjection = () =>
{
	const form_context = useFormContext()
	
	const title = form_context.watch('title');
	const recurrence = form_context.watch('recurrence') as Recurrence;
	
	
	const now = DateTime.local();
	
	
	let next_dts = nextAutomationDatetimes(recurrence, 10) as DateTime[];
	
	
	// console.log(next_dts);
	
	
	// TODO: Why is this sometimes invalid?
	next_dts = next_dts.filter(x => x.isValid);
	
	
	let projected_recurrences = next_dts.map(dt =>
		makeProjectedRecurrence(
			title + ' ' + dt?.toUTC().toISO().slice(0, 10),
			dt,
			now
		)
	);
	
	
	let elems = [];
	
	let generation_target_dts = projected_recurrences.map(x =>
		x.datetime.minus(recurrence.lead_time)
	)
	
	
	
	let generating_immediately = projected_recurrences
		.filter((x, i) =>
			(x.datetime.minus(recurrence.lead_time) <= now)
		);
	
	let generating_immediately_count = generating_immediately.length;
	
	
	console.log(now);
	console.log(now.toISO());
	console.log(generating_immediately_count);
	console.log(projected_recurrences);
	console.log(generation_target_dts);
	console.log(generation_target_dts.map(x => x.toISO()));
	
	
	if(generating_immediately_count)
	{
		elems.push(
			<ProjectionNote />
		)
		
		generating_immediately.forEach(x =>
			elems.push(
				<ProjectedRecurrenceCard
					projected={x}
				/>
			)
		)
	}
	
	
	
	for(let i = generating_immediately_count; i < projected_recurrences.length; i++)
	{
		elems.push(<ProjectionNote dt={generation_target_dts[i]} />)
		
		elems.push(
			<ProjectedRecurrenceCard
				projected={projected_recurrences[i]}
			/>
		)
	}
	
	
	
	return (
		<FieldWrapperGizmo
			label='Projections'
			help='Projecting when future work orders will be generated'
		>
			{/* <DatetimeList */}
			<Stack
				gap={1}
				padding={2}
			>
				{elems}
			</Stack>
		</FieldWrapperGizmo>
	)
}


export default RecurrenceProjection;